export const splitOtpDigits = (code) => {
  const digits = String(code || '').replace(/\D/g, '').slice(0, 6).split('');
  while (digits.length < 6) digits.push('');
  return digits;
};

export const listenForWebOtp = (onCode, signal) => {
  if (typeof window === 'undefined' || !window.OTPCredential) return () => {};
  navigator.credentials
    .get({ otp: { transport: ['sms'] }, signal })
    .then((cred) => { if (cred?.code) onCode(cred.code); })
    .catch(() => {});
  return () => {};
};
